import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Projects from "./pages/Projects";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AcadGarage from "./pages/AcadGarage";
import "./index.css";
import About from "./pages/About";
import Lenis from "@studio-freight/lenis";
import { useIsomorphicLayoutEffect } from "framer-motion";

function App() {
    console.log(
        "%c made with 🤍 by Hariprasad",
        "color:black; background:white; font-size:20px; font-weight:bold; font-family:monospace; letter-spacing: 1px;padding:12px 20px; border-radius:13px;"
    );
    console.log("Contact me @ https://wa.me/919345160259");

    useIsomorphicLayoutEffect(() => {
        const lenis = new Lenis({
            duration: 1.5,
            lerp: 0.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
            direction: "vertical", // vertical, horizontal
            gestureDirection: "vertical", // vertical, horizontal, both
            smooth: true,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        });

        //get scroll value
        lenis.on(
            "scroll",
            ({ scroll, limit, velocity, direction, progress }) => {
                console.log({ scroll, limit, velocity, direction, progress });
            }
        );

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Home />} path="/" />
                <Route element={<About />} path="/about" />
                <Route element={<AcadGarage />} path="/acadgarage" />
                <Route element={<Projects />} path="/projects" />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
